// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Menu {
  border-radius: 6px;
  border: 2px solid rgba(0, 177, 6, 0.8);
  min-width: 120px;
  padding: 0;
  font-family: inherit; }
  .Menu .menu-trigger {
    text-align: center; }
    .Menu .menu-trigger:after {
      content: "⋀";
      margin-left: 0.3rem; }
  .Menu .menu-item {
    display: block;
    border-bottom: 2px solid #00b106;
    color: initial; }
  .Menu .menu-item > *,
  .Menu .menu-trigger {
    display: block;
    color: initial;
    font-size: 1rem;
    font-weight: 500;
    padding: 0.5rem 1rem;
    cursor: pointer;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    .Menu .menu-item > *:hover,
    .Menu .menu-trigger:hover {
      background-color: rgba(0, 177, 6, 0.8);
      border-color: #00b106;
      color: white; }
  .Menu.expanded .menu-trigger::after {
    content: "⋁"; }
`, "",{"version":3,"sources":["webpack://./src/components/library/Menu.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,kBAAkB;EAClB,sCCC2B;EDA3B,gBAAgB;EAChB,UAAU;EACV,oBAAoB,EAAA;EALtB;IAQI,kBAAkB,EAAA;IARtB;MAWM,YAAS;MACT,mBAAmB,EAAA;EAZzB;IAiBI,cAAc;IACd,gCCfyB;IDgBzB,cAAc,EAAA;EAnBlB;;IAwBI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,qIAC8D,EAAA;IA/BlE;;MAkCM,sCC/BuB;MDgCvB,qBChCuB;MDiCvB,YAAY,EAAA;EApClB;IA0CM,YAAS,EAAI","sourcesContent":["@import \"../../style/colors\";\n\n.Menu {\n  border-radius: 6px;\n  border: 2px solid rgba($primaryGreen, 0.8);\n  min-width: 120px;\n  padding: 0;\n  font-family: inherit;\n\n  .menu-trigger {\n    text-align: center;\n\n    &:after {\n      content: \"⋀\";\n      margin-left: 0.3rem;\n    }\n  }\n\n  .menu-item {\n    display: block;\n    border-bottom: 2px solid $primaryGreen;\n    color: initial;\n  }\n\n  .menu-item > *,\n  .menu-trigger {\n    display: block;\n    color: initial;\n    font-size: 1rem;\n    font-weight: 500;\n    padding: 0.5rem 1rem;\n    cursor: pointer;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n    &:hover {\n      background-color: rgba($primaryGreen, 0.8);\n      border-color: $primaryGreen;\n      color: white;\n    }\n  }\n\n  &.expanded {\n    .menu-trigger::after {\n      content: \"⋁\";\n    }\n  }\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
